import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Profile from '../../Pages/Settings/Profile';
import Security from './Security';
import Notifications from './Notifications';
import ProfileManager from './ProfileManager';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Section() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value}
        textColor="#1E222B"
        TabIndicatorProps={{style: {background:'#00BC67'}}}
        
        indicatorColor="secondary"
         onChange={handleChange} 
         aria-label="basic tabs example"
         >
          <Tab label="Profile"
           {...a11yProps(0)} />
          {/* <Tab label="Projects" {...a11yProps(1)} /> */}
          <Tab label="Security" {...a11yProps(1)} />
          <Tab label="Notifications" {...a11yProps(2)} />
          <Tab label="Insurance Profile" {...a11yProps(3)} />
          <Tab label="Tax Profile" {...a11yProps(4)} />
         

        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
           <Profile/>
      </TabPanel>
      {/* <TabPanel value={value} index={1}>
      009898989
      </TabPanel> */}
      <TabPanel value={value} index={1}>
      <Security/>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <Notifications/>
      </TabPanel>
      <TabPanel value={value} index={3}>
      <ProfileManager type="insurance"/>
      </TabPanel>
      <TabPanel value={value} index={4}>
      <ProfileManager type="tax"/>
      </TabPanel>
      
    </Box>
  );
}
